module.exports = __webpack_public_path__ + "static/media/46.eca5b2c5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sports/svg/46.svg
// module id = 154
// module chunks = 0